import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import LoadingAnimation from "../../components/animation/LoadingAnimation";
import FloatingChatButton from "../../components/button/FloatingChatButton";
import Footer from "../../components/footer/Footer";
import Navbar from "../../components/navbar/Navbar";
import ProductDetails from "../../components/product/ProductDetails";
import ProductGallery from "../../components/product/ProductGallery";
import { productService } from "../../service/ProductService";

const Wrapper = styled.div`
  width: 100%;
`;
const Container = styled.div`
  margin: 5%;
  margin-bottom: 0px;
`;
const Space = styled.div`
  height: 40px;
`;
function ProductPage() {
  const { productId } = useParams();
  const [product, setProduct] = useState();
  const [loading, setLoading] = useState(true);
  const [galleryProducts, setGalleryProducts] = useState();

  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 50);
    }
  }, [productId, loading]);

  useEffect(() => {
    const fetchProduct = async (id) => {
      setLoading(true);
      productService.getProductById(
        id,
        (product) => {
          setProduct(product);
          setLoading(false);
        },
        {
          default: (message) => {
            alert(message);
            setProduct([]);
            setLoading(false);
          },
        },
      );
    };
    fetchProduct(productId);
  }, [productId]);

  useEffect(() => {
    const fetchProducts = async () => {
      product &&
      productService.getNProductByCategory(
          product.category._id,
          10,
          (products) => {
            setGalleryProducts(products);
          },
          {
            default: (message) => {
              alert(message);
            },
          },
        );
    };
    fetchProducts();
  }, [product]);

  return (
    <Wrapper>
      <FloatingChatButton />
      <Navbar />
      <Container>
        {loading && <LoadingAnimation height={"500px"} width={"700px"} />}

        {product && <ProductDetails product={product} />}
        {galleryProducts && (
          <ProductGallery
            galleryName={`Other products you may like`}
            products={galleryProducts}
            currentProductId={productId}
            navigateTo={`/products/${product.category.name}`}
          />
        )}
      </Container>

      <Space />
      <Space />
      <Footer />
    </Wrapper>
  );
}

export default ProductPage;
